import { useMutation, useQueryClient } from "@tanstack/react-query";
import adminApi from "../../api/adminApi";
type UpdateSubjectPayload = {
    id: number;
    data: {
        name: string,
    };
};

export const useUpdateSubject = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: ({ id, data }: UpdateSubjectPayload) =>
            adminApi.updateSubject(id, data),
        onSuccess: () => {
            queryClient.invalidateQueries({
                queryKey: ["subjects"],
            });
        },
    });
};

